import SbEditable from 'storyblok-react';
import { useMemo } from 'react';

import { NavContextProvider, WidgetContext } from '@widget/core';
import { WidgetLayout } from '../presets/WidgetLayout';
import { WidgetItemSchema } from './schemas';
import { renderStep } from './renderStep';
import { WidgetProviders } from './WidgetProviders';

import type { Flags, WidgetContextValue } from '@widget/core';
import type { SbEditableContent } from 'storyblok-react';
import type { Richtext } from 'storyblok-js-client';
import type { ZodError } from 'zod';

export type WidgetPreviewProps = {
  widgetStory: Record<string, unknown>;
};

export const WidgetPreview = ({ widgetStory }: WidgetPreviewProps) => {
  const { widgetStoryParsed, error } = useMemo(() => {
    try {
      return { widgetStoryParsed: WidgetItemSchema.parse(widgetStory) };
    } catch (error) {
      return { error: error as ZodError };
    }
  }, [widgetStory]);
  const renderSteps = (steps: any) => {
    return steps?.map((step: any, i: number) => {
      if (i == 1) {
        return (
          <SbEditable key={step._uid} content={step as SbEditableContent}>
            <div
              style={{
                border: '1px solid #000',
                width: '100%',
                margin: '10px auto',
              }}
            >
              <div>Hello step</div>
              {renderStep(step)}
            </div>
          </SbEditable>
        );
      }
      return (
        <SbEditable key={step._uid} content={step as SbEditableContent}>
          <div
            style={{
              border: '1px solid #000',
              width: '100%',
              margin: '10px auto',
            }}
          >
            {renderStep(step)}
          </div>
        </SbEditable>
      );
    });
  };

  if (error) {
    return <pre style={{ padding: 20 }}>{JSON.stringify(error, null, 2)}</pre>;
  }

  return (
    <WidgetProviders market={'de'} flags={{} as Flags} trustIcons={[]} widgetXBaseApi={'/'}>
      <SbEditable content={widgetStoryParsed.content as SbEditableContent}>
        <WidgetContext.Provider
          value={
            {
              allStepsPreviewMode: true,
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              commit: () => {},
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              skip: () => {},
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              getStep: () => {},
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              getStepProps: () => {},
              steps: [],
              history: [],
              // this is added strictly to make the timeslot confirmation page work on Storyblok
              getFormData: () => ({
                timeslot: new Date(),
                contactForm: {},
              }),
            } as unknown as WidgetContextValue
          }
        >
          {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
          <NavContextProvider activeId={''} back={() => {}} next={() => {}} goTo={() => {}}>
            <WidgetLayout
              footerItems={widgetStoryParsed?.content?.footer}
              logo={widgetStoryParsed?.content?.logo}
              contactPerson={widgetStoryParsed?.content?.contactPerson}
              marketingHeaderText={widgetStoryParsed?.content?.marketingHeaderText as Richtext}
            >
              {renderSteps(widgetStoryParsed?.content?.steps)}
            </WidgetLayout>
          </NavContextProvider>
        </WidgetContext.Provider>
      </SbEditable>
    </WidgetProviders>
  );
};
